/** @format */

import { useContext } from 'react';
import { BusinessContext } from 'providers';

function useBusiness() {
  return useContext(BusinessContext);
}

export { useBusiness };
